import { MockDebug } from '@tino-frontend/mocks'

import { quizAPIMock } from '@fixtures/apis/quiz'

import { situationAPIMock } from '@fixtures/apis/situation'
import { REACT_APP_CORE_API_URL } from 'constants/envs'

const MockDebugSituation: MockDebug = {
  title: 'situation',
  path: `${REACT_APP_CORE_API_URL}/me/situation`,
  method: 'get',
  delay: 0,
  options: [
    {
      id: 'mock-situation-kyc-pending',
      title: 'kyc-pending',
      status: 200,
      data: situationAPIMock.build({
        status: 'waiting_docs',
      }),
    },
    {
      id: 'mock-situation-kyc-pending-quiz-rejected',
      title: 'kyc-pending-quiz-rejected',
      status: 200,
      data: situationAPIMock.build({
        kyc_mode: 'docs',
        status: 'waiting_docs',
      }),
    },
  ],
}

// Service: situation and credit limit
const MockDebugQuizQuestions: MockDebug = {
  title: 'quiz-questions',
  path: `${REACT_APP_CORE_API_URL}/onboarding/quiz`,
  method: 'post',
  delay: 0,
  options: [
    {
      id: 'mock-quiz-questions',
      title: 'questions',
      status: 200,
      data: quizAPIMock.source,
    },
  ],
}

const MockDebugQuizAnswer: MockDebug = {
  title: 'quiz-answer',
  path: `${REACT_APP_CORE_API_URL}/onboarding/quiz/:id/answer`,
  method: 'post',
  delay: 1000,
  options: [
    {
      id: 'mock-quiz-answer-approved',
      title: 'answer-approved',
      status: 200,
      data: {
        approved: true,
      },
    },
    {
      id: 'mock-quiz-answer-rejected',
      title: 'answer-rejected',
      status: 200,
      data: {
        approved: false,
      },
    },
  ],
}

export const MockDebugQuizSituation = [
  MockDebugSituation,
  MockDebugQuizQuestions,
  MockDebugQuizAnswer,
]
